import { useRef } from 'react'
import { useParams } from 'react-router-dom'

// The editor holds one session per persisted declaration. Switching between two declarations
// must start a new session, or the previously opened declaration's form state is saved against
// the newly opened one. Adopting the id of a declaration that was just created in this session
// must not, or the create's own result is torn down and refetched.
export default function useDeclarationSessionKey() {
  const { transitId } = useParams()
  const previousTransitId = useRef(transitId)
  const sessionKey = useRef(transitId ?? 'new')

  if (previousTransitId.current !== transitId) {
    if (previousTransitId.current != null) {
      sessionKey.current = transitId ?? 'new'
    }
    previousTransitId.current = transitId
  }

  return sessionKey.current
}
